export const CHANGE_KEYWORD = 'CHANGE_KEYWORD';
export const SAVE_COMPANY_LIST_INFO = 'SAVE_COMPANY_LIST_INFO';
export const CHANGE_FILTERS = 'CHANGE_FILTERS';
export const RESET_FILTERS = 'RESET_FILTERS';
export const SAVE_FILTERS = 'SAVE_FILTERS';